import { Component, OnInit, Input } from '@angular/core';
import { TabService } from '../../../../../../services';

@Component({
  selector: 'spk-tab',
  templateUrl: './spk-tab.component.html',
  styleUrls: ['./spk-tab.component.scss']
})
export class SpkTabComponent implements OnInit {

  @Input() name: string;
  @Input() label: string;
  @Input() class: string;
  @Input() active: boolean;

  constructor(private tabService: TabService) { }

  ngOnInit() {
  }

  updateTab(tab: string) {
    this.tabService.updateTab(tab);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/framework/spk/layouts/tabs/spk-tab/spk-tab.component.ts